const EVENT_TYPES = {
  1: 'My Shifts', // blankish, red, blue, green, orange, purple, yellow
  2: 'Not My Shifts', // blankish, red, blue, green, orange, purple, yellow **only can see this group security key
  3: 'Open Shifts', // same color no matter who you are (WHITE)
  4: 'Pending Request Open Shifts', // blankish, red, blue, green, orange, purple, yellow
  5: 'Pending Call Off Shifts', // blankish, red, blue, green, orange, purple, yellow
  6: 'Appointments Shifts', // blankish, red, blue, green, orange, purple, yellow
};
const EVENT_COLORS = {
  red: [210, 40, 40],
  blue: [120, 170, 215],
  green: [70, 190, 120],
  orange: [250, 145, 70],
  purple: [155, 140, 235],
  yellow: [235, 230, 170],
  white: [255, 255, 255],
  defaultMute: [220, 220, 220],
  neonGreen: [57, 255, 20],
};

const SchedulingCalendar = (function () {
  // DOM
  let ScheduleCalendar;
  let locationDropdownEle;
  let employeeDropdownEle;
  let shiftTypeDropdownEle;
  let shiftTypeNote;
  let pubUnpubButtonEle;
  let copyShiftsButtonEle;
  let newShiftButtonEle;
  let openShiftYesRadio;
  let openShiftNoRadio;
  let otherEmployeeShiftYesRadio;
  let otherEmployeeShiftNoRadio;
  let otherEmployeeShiftWrapEle;

  // DATA
  let schedules;
  let appointments;
  let calendarEvents;
  let eventsArray;
  let calendarAppointments;
  let locations;
  let employees;
  let employeesByVendorLocation;

  // GLOBALS
  let currentCalView;
  let dateRange;
  let selectedLocationId;
  let selectedEmployeeId;
  let selectedShiftType;
  let viewOptionShifts;
  // T.215199: 'yes'/'no' - non-scheduler toggle to show all published shifts for the
  // displayed locations (other employees' shifts), only available in Week/Day view.
  let showOtherEmployeeShifts;

  // T.215199: when a non-scheduler turns on "Show Other Employee Shifts", fetch every
  // published shift for the displayed locations by passing personId '%'; otherwise keep
  // the existing per-user scope.
  function getEffectiveEmployeeId() {
    if (!$.session.schedulingSecurity && showOtherEmployeeShifts === 'yes') {
      return '%';
    }
    return selectedEmployeeId;
  }

  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.text.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.text.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }
  function showSuccessFailPopup(success, message, removeOverlay = true) {
    if (success) {
      if (!message) message = 'SAVED';
      successfulSave.show(message);
      setTimeout(function () {
        successfulSave.hide(removeOverlay);
      }, 1000);
    } else {
      if (!message) message = 'ERROR SAVING';
      failSave.show(message);
      setTimeout(function () {
        failSave.hide(removeOverlay);
      }, 1000);
    }
  }
  function abbreviateAppointment(str) {
    if (!str || str === '') return '';

    const map = {
      appointment: 'appt',
    };

    return str
      .split(' ')
      .map(word => map[word.toLowerCase()] || word)
      .join(' ');
  }
  function hasEventsForViewableDateRange(dateRangeInView) {
    return dateRange.start <= dateRangeInView.start && dateRange.end >= dateRangeInView.end;
  }

  // Calendar
  //-----------------------------------------------------------------------
  function getEventType(personID, callOffStatus, requestShiftStatus) {
    if (!personID) {
      if (!callOffStatus && (requestShiftStatus === 'D' || requestShiftStatus === '')) {
        return { type: EVENT_TYPES[3], id: 3 };
      }

      if (requestShiftStatus === 'P') {
        return { type: EVENT_TYPES[4], id: 4 };
      }
    }

    if (personID.toString() === $.session.PeopleId) {
      if (callOffStatus === 'P') {
        return { type: EVENT_TYPES[5], id: 5 };
      }

      return { type: EVENT_TYPES[1], id: 1 };
    }

    return { type: EVENT_TYPES[2], id: 2 };
  }
  function getEventColor(typeId, color) {
    if (typeId === 3) {
      // open shifts
      return EVENT_COLORS.white;
    }

    if (!color) {
      return EVENT_COLORS.defaultMute;
    }

    return EVENT_COLORS[color];
  }
  function formatServiceDate(serviceDate, dateScheduled) {
    let date = serviceDate ? serviceDate : dateScheduled;
    return date.split(' ')[0];
  }
  function formatDescription(firstName, lastName) {
    if (!lastName || !firstName) return '';

    return `${lastName}, ${firstName}`;
  }
  function getEventTotalTime(dirtyStart, dirtyEnd) {
    if (!dirtyStart || !dirtyEnd) return '';

    const [startHours, startMinutes, startSeconds] = dirtyStart.split(':').map(Number);
    const [endHours, endMinutes, endSeconds] = dirtyEnd.split(':').map(Number);

    const startTimeMilliseconds = (startHours * 3600 + startMinutes * 60 + startSeconds) * 1000;
    const endTimeMilliseconds = (endHours * 3600 + endMinutes * 60 + endSeconds) * 1000;

    let milliseconds = endTimeMilliseconds - startTimeMilliseconds;

    if (milliseconds < 0) {
      milliseconds += 24 * 3600 * 1000;
    }

    const hours = milliseconds / (1000 * 60 * 60);
    return hours === 0 ? '' : `(${parseFloat(hours.toFixed(2))})`;
  }
  // T.215199: period key for scoping other-employee shifts. The calendar caches a six-week window
  // and navigates within it, so scoping must be intrinsic to each shift's own date (not the current
  // view date). In Week view the key is the Sunday-start of the shift's week; in Day view it is the
  // shift's exact day. All math is on the date parts (local), so there are no timezone shifts.
  function scheduledPeriodKey(dateStr) {
    if (!dateStr) return '';
    if (currentCalView === 'day') return dateStr;
    const [y, m, d] = dateStr.split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    dt.setDate(dt.getDate() - dt.getDay()); // back to Sunday
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${dt.getFullYear()}-${mm}-${dd}`;
  }
  // T.215199: single source of truth for the Location = All location filter. Restricts events to
  // the user's available locations, and when "Show Other Employee Shifts" is on, further restricts
  // OTHER employees' ASSIGNED shifts (type 2) to a location+period where the user actually has their
  // OWN shift (types 1/5) - i.e. only where the user is scheduled that same week (Week view) or day
  // (Day view). The user's own shifts and open shifts (types 3/4) are never restricted - open shifts
  // stay governed solely by "Show Open Shifts". Used by both getCalendarEvents (fetch) and
  // refilterEventsByAvailableLocations (client re-filter) so the Show Open Shifts toggle can't
  // bypass the scoping and re-introduce another location's assigned shifts.
  function applyDisplayedLocationFilter(events) {
    if (selectedLocationId !== '%') return events;
    if (!$.session.schedulingSecurity && showOtherEmployeeShifts === 'yes') {
      const ownScheduleKeys = new Set(
        events
          .filter(ev => ev.typeId === 1 || ev.typeId === 5)
          .map(ev => `${ev.locationId}|${scheduledPeriodKey(ev.date)}`),
      );
      return events.filter(ev => {
        if (!locations.find(loc => loc.locationId === ev.locationId)) return false;
        if (ev.typeId === 2) {
          return ownScheduleKeys.has(`${ev.locationId}|${scheduledPeriodKey(ev.date)}`);
        }
        return true;
      });
    }
    return events.filter(ev => locations.find(loc => loc.locationId === ev.locationId));
  }
  function refilterEventsByAvailableLocations() {
    calendarEvents = applyDisplayedLocationFilter(eventsArray);
    renderCalendarEvents();
  }
  async function getCalendarEvents(locationID = '%', peopleID = '%') {
    const newDateRange = ScheduleCalendar.getSixWeekDateRange();
    dateRange = { ...newDateRange };

    const tempschedules = (
      await _UTIL.fetchData('getSchedulesForSchedulingModuleNew', {
        locationId: locationID,
        personId: peopleID,
        dateRangeStart: $.session.flag[192697] ? dateRange.start : null,
        dateRangeEnd: $.session.flag[192697] ? dateRange.end : null,
      })
    ).getSchedulesForSchedulingModuleNewResult;

    const tempschIds = new Set();
    schedules = tempschedules.filter(sch => {
      if (tempschIds.has(sch.shiftId)) {
        return false;
      } else {
        tempschIds.add(sch.shiftId);
        return true;
      }
    });

    const schIds = new Set();
    eventsArray = schedules
      .filter(sched => {
        const timeRegEx = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
        const isStartTimeValid = timeRegEx.test(sched.startTime);
        const isEndTimeValid = timeRegEx.test(sched.endTime);

        const { type, id } = getEventType(
          sched.personID,
          sched.callOffStatus,
          sched.requestShiftStatus,
        );

        if (!isStartTimeValid || !isEndTimeValid || sched.serviceDate === '') {
          return false;
        }

        // T.215199: normally a non-scheduler never sees another employee's shift (id 2).
        // When "Show Other Employee Shifts" is on, let those published shifts through.
        if (
          !type ||
          (id === 2 && !$.session.schedulingSecurity && showOtherEmployeeShifts !== 'yes')
        ) {
          return false;
        }

        if (schIds.has(sched.shiftId)) {
          return false;
        } else {
          schIds.add(sched.shiftId);
          return true;
        }
      })
      .map(sch => {
        const { type, id } = getEventType(sch.personID, sch.callOffStatus, sch.requestShiftStatus);

        const serviceDate = formatServiceDate(sch.serviceDate, sch.dateScheduled);
        const startTime = `${serviceDate} ${sch.startTime}`;
        const endTime = `${serviceDate} ${sch.endTime}`;

        const length = getEventTotalTime(sch.startTime, sch.endTime);
        const description = formatDescription(sch.firstName, sch.lastName);
        const color = getEventColor(id, sch.color);

        // store on cache obj
        sch.typeId = id;
        sch.colorCode = color;
        sch.length = length;

        return {
          eventId: sch.shiftId,
          date: serviceDate,
          startTime: startTime,
          endTime: endTime,
          length: length,
          description: description,
          name: id === 3 ? 'Open Shift' : description,
          typeId: id,
          typeName: type,
          locationId: sch.locationId,
          locationName: sch.locationName,
          publishedDate: sch.publishDate,
          color: color,
          consumers: sch.consumerNames,
          personId: sch.personID,
          // T.215199: mark shifts belonging to other employees so the cell renders dimmed.
          otherEmployeeShift:
            !$.session.schedulingSecurity && showOtherEmployeeShifts === 'yes' && id === 2,
        };
      });

    return applyDisplayedLocationFilter(eventsArray);
  }
  function formatEndTimeForAppointments(endTimeObj) {
    const intlDateFull = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      weekday: 'long',
      hour12: false,
    }).format(endTimeObj);

    const intlDate = new Intl.DateTimeFormat('en-US').format(endTimeObj);

    const timeString = `${intlDateFull.split(',')[2].split(' ')[1]}:00`;

    return `${intlDate} ${timeString}`;
  }
  async function getCalendarAppointments(locationID = '%') {
    appointments = (
      await _UTIL.fetchData('getScheduleApptInformationNew', { locationId: locationID })
    ).getScheduleApptInformationNewResult;

    const appointmentArray = appointments.map(appt => {
      const serviceDate = formatServiceDate(appt.serviceDate, appt.dateScheduled);
      const startTimeObj = new Date(`${serviceDate} ${appt.timeScheduled}`);
      const endTimeObj = dates.addHours(startTimeObj, 1);
      const startTime = `${new Intl.DateTimeFormat('en-US').format(startTimeObj)} ${
        appt.timeScheduled
      }`;
      const endTime = formatEndTimeForAppointments(endTimeObj);
      const color = getEventColor(6, appt.color);
      // const color = [57, 255, 20];

      // store on cache obj
      appt.shiftId = appt.medTrackingId;
      appt.typeId = 6;
      appt.colorCode = color;
      appt.length = '(1)';
      appt.startTime = startTime.split(' ')[1];
      appt.endTime = endTime.split(' ')[1];

      return {
        eventId: appt.medTrackingId,
        date: serviceDate,
        startTime: startTime,
        endTime: endTime,
        length: appt.length,
        description: abbreviateAppointment(appt.typeDescription),
        name: appt.consumerName,
        staffName: appt.takenToApptBy,
        typeId: appt.typeId,
        typeName: EVENT_TYPES[appt.typeId],
        locationId: appt.locationId,
        locationName: appt.locationName,
        publishedDate: appt.publishDate,
        color: color,
        timeScheduled: appt.timeScheduled,
      };
    });

    // if (selectedLocationId === '%') {
    //   return appointmentArray.filter(appt => {
    //     const hasLoc = locations.find(loc => loc.locationId === appt.locationId);
    //     return hasLoc ? true : false;
    //   });
    // }

    return appointmentArray;
  }
  //
  function renderCalendarEvents() {
    if (selectedLocationId === '%') {
      ScheduleCalendar.renderGroupedEvents([...calendarEvents, ...calendarAppointments], {
        groupBy: 'locationId',
        groupName: 'locationName',
      });
    } else if (selectedEmployeeId === '%') {
      ScheduleCalendar.renderGroupedEvents([...calendarEvents, ...calendarAppointments], {
        groupBy: 'personId',
        groupName: 'name',
      });
    } else {
      ScheduleCalendar.renderEvents([...calendarEvents, ...calendarAppointments]);
    }
  }
  //
  function handleCalendarEventClick(eventTarget, clickEvent) {
    if (clickEvent.detail > 1 && eventTarget.closest('.day')) return;

    if (eventTarget.classList.contains('day') && document.body.classList.contains('mobileActive')) {
      const dateISO = eventTarget.dataset.date;
      const shiftIds = ScheduleCalendar.getShiftIdsByDay(dateISO);

      if (!shiftIds || !shiftIds.length) {
        const targetDate = eventTarget.dataset.date;
        const targetDateTime = eventTarget.dataset.datetime;

        SchedulingShifts.showPopup({
          eventTypeId: '',
          data: null,
          isCopy: false,
          selectedDate: targetDate,
        });
      } else {
        const targetEvents = [...appointments, ...schedules].filter(ev =>
          shiftIds.includes(ev.shiftId),
        );
        SchedulingShifts.showGroupPopup(targetEvents, dateISO);
      }

      return;
    }

    if (eventTarget.classList.contains('eventCellGroupEle')) {
      const dayDiv = eventTarget.parentElement.parentElement;
      if (dayDiv.classList.contains('day')) {
        const dateISO = dayDiv.dataset.date;
        const shiftIds = ScheduleCalendar.getShiftIdsByDay(dateISO);

        if (!shiftIds || !shiftIds.length) return;

        const targetEvents = [...appointments, ...schedules].filter(ev =>
          shiftIds.includes(ev.shiftId),
        );
        SchedulingShifts.showGroupPopup(targetEvents, dateISO);
      }

      return;
    }

    if (eventTarget.classList.contains('eventCellEle')) {
      const eventTypeId = eventTarget.dataset.typeId;
      const shiftId = eventTarget.dataset.eventId;
      const targetEvent = [...appointments, ...schedules].find(ev => ev.shiftId == shiftId);

      SchedulingShifts.showPopup({
        eventTypeId,
        data: targetEvent,
        isCopy: false,
      });

      return;
    }

    if (eventTarget.classList.contains('copyShiftIcon')) {
      const dayCellEle = eventTarget.closest('.eventCellEle');
      const eventTypeId = dayCellEle.dataset.typeId;
      const shiftId = dayCellEle.dataset.eventId;
      const targetEvent = [...appointments, ...schedules].find(ev => ev.shiftId == shiftId);

      SchedulingShifts.showPopup({
        eventTypeId,
        data: { ...targetEvent },
        isCopy: true,
      });

      return;
    }

    // 196780
    if (
      $.session.flag[196780] &&
      eventTarget.classList.contains('day') &&
      currentCalView === 'month'
    ) {
      const targetDate = eventTarget.dataset.date;
      const targetDateTime = eventTarget.dataset.datetime;

      SchedulingShifts.showPopup({
        eventTypeId: '',
        data: null,
        isCopy: false,
        selectedDate: targetDate,
      });
    }
  }

  // MAIN DOM
  //-----------------------------------------------------------------------
  function populateLocationDropdown() {
    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    dropdown.populate(locationDropdownEle, dropdownData, selectedLocationId);
  }
  function populateEmployeeGroupDropdown() {
    let locationEmployeeData = [];
    let otherEmployeeData = [];
    let currentSelectedEmployeeExists = false;
    let hasUserId = false;

    employeesByVendorLocation.forEach(employee => {
      if (employee.Person_Id === selectedEmployeeId) currentSelectedEmployeeExists = true;
      if (employee.Person_Id === $.session.PeopleId) hasUserId = true;

      if (employee.Preferred === 'Y') {
        locationEmployeeData.push({ value: employee.Person_Id, text: employee.EmployeeName });
      } else {
        otherEmployeeData.push({ value: employee.Person_Id, text: employee.EmployeeName });
      }
    });

    locationEmployeeData.sort((a, b) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    otherEmployeeData.sort((a, b) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    const locationEmployeeGroup = {
      groupLabel: 'Preferred at This Location',
      groupId: 'scheduleLocationEmployee',
      dropdownValues: locationEmployeeData,
    };
    const otherEmployeeGroup = {
      groupLabel: 'Other Employees',
      groupId: 'scheduleOtherEmployee',
      dropdownValues: otherEmployeeData,
    };

    const groupDropdownData = [];
    if (locationEmployeeData.length > 0) {
      groupDropdownData.push(locationEmployeeGroup);
    }
    groupDropdownData.push(otherEmployeeGroup);

    if (selectedEmployeeId !== '%') {
      if (!currentSelectedEmployeeExists) {
        if (!hasUserId) {
          selectedEmployeeId = '%';
        } else {
          selectedEmployeeId = $.session.PeopleId;
        }
      }
    }

    dropdown.groupingPopulate({
      dropdown: employeeDropdownEle,
      data: groupDropdownData,
      nonGroupedData: [
        {
          value: '%',
          text: 'All',
        },
      ],
      defaultVal: selectedEmployeeId,
    });
  }
  function populateEmployeeDropdown() {
    if ($.session.schedulingSecurity && selectedLocationId !== '%') {
      populateEmployeeGroupDropdown();
      return;
    }

    let dropdownData = [];

    if ($.session.schedulingSecurity) {
      let currentSelectedEmployeeExists = false;
      let hasUserId = false;

      employees.forEach(d => {
        if (d.Person_Id === selectedEmployeeId) currentSelectedEmployeeExists = true;
        if (d.Person_Id === $.session.PeopleId) hasUserId = true;

        dropdownData.push({
          value: d.Person_Id,
          text: d.EmployeeName,
        });
      });

      dropdownData.sort(sortEmployeeString);

      if (!currentSelectedEmployeeExists && selectedEmployeeId !== '%') {
        if (!hasUserId) {
          selectedEmployeeId = '%';
        } else {
          selectedEmployeeId = $.session.PeopleId;
        }
      }
    } else {
      dropdownData.unshift({
        value: $.session.PeopleId,
        text: `${$.session.LName}, ${$.session.Name}`,
      });
    }

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    if (viewOptionShifts === 'yes') {
      dropdownData.unshift({
        value: 'none',
        text: '(none)',
      });
    }

    dropdown.populate(employeeDropdownEle, dropdownData, selectedEmployeeId);
  }
  function buildLocationDropdown() {
    const dropdownEle = dropdown.build({
      dropdownId: 'locationDropdown',
      label: 'Location:',
      style: 'secondary',
    });

    dropdownEle.classList.add('mainLocationDropdown');

    dropdownEle.addEventListener('change', async event => {
      selectedLocationId = event.target.options[event.target.selectedIndex].value;

      if ($.session.schedulingSecurity && selectedLocationId !== '%') {
        employeesByVendorLocation = (
          await _UTIL.fetchData('getEmployeesByLocation', { locationId: selectedLocationId })
        ).getEmployeesByLocationResult;
      }

      populateEmployeeDropdown();

      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;

      renderCalendarEvents();
    });

    return dropdownEle;
  }
  function buildEmployeeDropdown() {
    const dropdownEle = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee:',
      style: 'secondary',
    });

    dropdownEle.classList.add('mainEmployeeDropdown');

    dropdownEle.addEventListener('change', async event => {
      let reFilterOutOpenShifts = false;

      selectedEmployeeId = event.target.options[event.target.selectedIndex].value;

      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;

      renderCalendarEvents();

      if (reFilterOutOpenShifts) {
        const filterCheck = value => value !== 3;
        ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
      }
    });

    return dropdownEle;
  }
  function updateShiftTypeNote(shiftCount) {
    shiftTypeNote.textContent = `Un-Published Shifts: ${shiftCount}`;

    if (shiftCount === 0) {
      shiftTypeNote.classList.remove('error');
    } else {
      shiftTypeNote.classList.add('error');
    }
  }
  function buildShiftTypeDropdown() {
    const shiftTypeWrap = document.createElement('div');
    shiftTypeWrap.classList.add('shiftTypeWrap');
    shiftTypeNote = document.createElement('p');
    shiftTypeNote.textContent = 'Un-Publishsed Shifts: 0';
    const dropdownEle = dropdown.build({
      dropdownId: 'shiftTypeDropdown',
      label: 'Show:',
      style: 'secondary',
    });

    dropdownEle.addEventListener('change', event => {
      selectedShiftType = event.target.options[event.target.selectedIndex].value;

      if (selectedShiftType === '0') {
        ScheduleCalendar.filterEventsBy({
          resetFilter: true,
          filterKey: 'publishedDate',
        });

        return;
      }

      const filterCheck = selectedShiftType === '1' ? value => !!value : value => !value;
      ScheduleCalendar.filterEventsBy({ filterKey: 'publishedDate', filterCheck });
    });

    selectedShiftType = '0';

    dropdown.populate(
      dropdownEle,
      [
        {
          value: '0',
          text: 'All Shifts',
        },
        {
          value: '1',
          text: 'Published Shifts',
        },
        {
          value: '2',
          text: 'Un-Published Shifts',
        },
      ],
      selectedShiftType,
    );

    shiftTypeWrap.appendChild(dropdownEle);
    shiftTypeWrap.appendChild(shiftTypeNote);

    return shiftTypeWrap;
  }
  function buildPubUnpubSchedulesButton() {
    const buttonEle = button.build({
      text: 'Publish / Un-Publish Schedules',
      classNames: ['pubUnpubButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      const pubUnpubCallback = async (data, pubOrUnpub) => {
        const success = (
          await _UTIL.fetchData('publishShift', {
            publish: pubOrUnpub,
            ...data,
          })
        ).publishShiftResult;

        showSuccessFailPopup(success);

        const [eventsResp, appointmentsResp] = await Promise.all([
          getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
          getCalendarAppointments(selectedLocationId),
        ]);

        calendarEvents = eventsResp;
        calendarAppointments = appointmentsResp;
        renderCalendarEvents();
      };

      PublishUnpublishSchedules.showPopup(employees, locations, pubUnpubCallback);
    });

    return buttonEle;
  }
  function buildNewShiftButton() {
    const buttonEle = button.build({
      text: 'Add New Shift',
      classNames: ['newShiftButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      SchedulingShifts.showPopup({
        eventTypeId: '',
        data: null,
        isCopy: false,
      });
    });

    return buttonEle;
  }
  function buildCopyShiftsButton() {
    const buttonEle = button.build({
      text: 'Copy Shifts',
      classNames: ['copyShiftButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      CopyScheduleShifts.showPopup();
    });

    return buttonEle;
  }
  function buildOpenShiftViewToggleButton() {
    const radioContainer = document.createElement('div');
    radioContainer.classList.add('openShiftWrap');

    const radioTitle = document.createElement('p');
    radioTitle.innerText = 'Show Open Shifts';

    const radioDiv = document.createElement('div');
    openShiftYesRadio = input.buildRadio({
      text: 'Yes',
      id: 'yes',
      name: 'openShift',
      isChecked: viewOptionShifts === 'yes' ? true : false,
      attributes: [{ key: 'value', value: 'yes' }],
    });
    openShiftNoRadio = input.buildRadio({
      text: 'No',
      id: 'no',
      name: 'openShift',
      isChecked: viewOptionShifts === 'yes' ? false : true,
      attributes: [{ key: 'value', value: 'no' }],
    });
    radioDiv.appendChild(openShiftYesRadio);
    radioDiv.appendChild(openShiftNoRadio);

    radioDiv.addEventListener('change', async e => {
      viewOptionShifts = e.target.id.toLowerCase();

      if (!$.session.schedulingSecurity) {
        const includeOpenShiftLocations = viewOptionShifts === 'yes' ? 'Y' : 'N';
        locations = (
          await _UTIL.fetchData('getLocationDropdownForSchedulingNew', {
            showOpenShifts: includeOpenShiftLocations,
          })
        ).getLocationDropdownForSchedulingNewResult;
        populateLocationDropdown();
      }

      if (viewOptionShifts === 'no') {
        if (selectedEmployeeId === 'none') {
          selectedEmployeeId = $.session.PeopleId;
          renderCalendarEvents();
        } else {
          const filterCheck = value => value !== 3 && value !== 4;
          ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
        }
      } else {
        refilterEventsByAvailableLocations();
        ScheduleCalendar.filterEventsBy({ resetFilter: true, filterKey: 'typeId' });
      }

      populateEmployeeDropdown();
    });

    radioContainer.appendChild(radioTitle);
    radioContainer.appendChild(radioDiv);

    return radioContainer;
  }
  // T.215199: re-apply the current "Show Open Shifts" visibility after a full re-render,
  // so toggling other-employee shifts does not resurrect hidden open shifts.
  function reapplyOpenShiftFilter() {
    if (viewOptionShifts === 'no') {
      const filterCheck = value => value !== 3 && value !== 4;
      ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
    }
  }
  // T.215199: refetch events using the effective employee scope ('%' when showing other
  // employees' shifts) and re-render.
  async function reloadCalendarEventsForOtherShifts() {
    const [eventsResp, appointmentsResp] = await Promise.all([
      getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
      getCalendarAppointments(selectedLocationId),
    ]);
    calendarEvents = eventsResp;
    calendarAppointments = appointmentsResp;
    renderCalendarEvents();
    reapplyOpenShiftFilter();
  }
  // T.215199: the toggle is only shown to non-schedulers, and only in Week/Day view.
  function updateOtherEmployeeShiftToggleVisibility() {
    if (!otherEmployeeShiftWrapEle) return;
    const shouldShow =
      !$.session.schedulingSecurity && (currentCalView === 'week' || currentCalView === 'day');
    otherEmployeeShiftWrapEle.classList.toggle('hidden', !shouldShow);
  }
  function buildOtherEmployeeShiftToggleButton() {
    const radioContainer = document.createElement('div');
    radioContainer.classList.add('openShiftWrap', 'otherEmployeeShiftWrap');

    const radioTitle = document.createElement('p');
    radioTitle.innerText = 'Show Other Employee Shifts';

    const radioDiv = document.createElement('div');
    otherEmployeeShiftYesRadio = input.buildRadio({
      text: 'Yes',
      id: 'otherEmployeeShiftYes',
      name: 'otherEmployeeShift',
      isChecked: showOtherEmployeeShifts === 'yes',
      attributes: [{ key: 'value', value: 'yes' }],
    });
    otherEmployeeShiftNoRadio = input.buildRadio({
      text: 'No',
      id: 'otherEmployeeShiftNo',
      name: 'otherEmployeeShift',
      isChecked: showOtherEmployeeShifts !== 'yes',
      attributes: [{ key: 'value', value: 'no' }],
    });
    radioDiv.appendChild(otherEmployeeShiftYesRadio);
    radioDiv.appendChild(otherEmployeeShiftNoRadio);

    radioDiv.addEventListener('change', async e => {
      showOtherEmployeeShifts = e.target.value;
      await reloadCalendarEventsForOtherShifts();
    });

    radioContainer.appendChild(radioTitle);
    radioContainer.appendChild(radioDiv);

    return radioContainer;
  }
  function buildFilter() {
    const accordionWrapEle = document.createElement('div');
    const accordionTriggerEle = document.createElement('div');
    const accordionContentEle = document.createElement('div');
    const contentWrapEle = document.createElement('div');

    accordionWrapEle.className = 'navAccordion';
    accordionTriggerEle.className = 'navAccordionTrigger';
    accordionContentEle.className = 'navAccordionContent closed';
    contentWrapEle.className = 'navAccordionContentWrapEle';

    accordionTriggerEle.innerHTML = `${icons.keyArrowDown} <p>Filter Calendar</p>`;

    accordionWrapEle.appendChild(accordionTriggerEle);
    accordionWrapEle.appendChild(accordionContentEle);
    accordionContentEle.appendChild(contentWrapEle);

    locationDropdownEle = buildLocationDropdown();
    employeeDropdownEle = buildEmployeeDropdown();
    shiftTypeDropdownEle = buildShiftTypeDropdown();
    const openShiftViewToggleEle = buildOpenShiftViewToggleButton();

    contentWrapEle.appendChild(locationDropdownEle);
    contentWrapEle.appendChild(employeeDropdownEle);
    contentWrapEle.appendChild(shiftTypeDropdownEle);
    contentWrapEle.appendChild(openShiftViewToggleEle);

    if (!$.session.schedulingSecurity) {
      contentWrapEle.removeChild(shiftTypeDropdownEle);

      //employeeDropdownEle.classList.add('disabled');
      input.disableInputField(employeeDropdownEle);

      // T.215199: non-schedulers get the "Show Other Employee Shifts" toggle (Week/Day only).
      otherEmployeeShiftWrapEle = buildOtherEmployeeShiftToggleButton();
      contentWrapEle.appendChild(otherEmployeeShiftWrapEle);
      updateOtherEmployeeShiftToggleVisibility();
    }

    accordionTriggerEle.addEventListener('click', e => {
      accordionContentEle.classList.toggle('closed');
    });

    return accordionWrapEle;
  }
  function build() {
    const scheduleWrap = document.createElement('div');
    scheduleWrap.classList.add('scheduleWrap');

    const scheduleNav = document.createElement('div');
    scheduleNav.classList.add('scheduleNav');

    const scheduleFilter = buildFilter();

    const colRight = document.createElement('div');
    colRight.classList.add('colRight');

    newShiftButtonEle = buildNewShiftButton();
    copyShiftsButtonEle = buildCopyShiftsButton();
    pubUnpubButtonEle = buildPubUnpubSchedulesButton();

    if ($.session.schedulingSecurity) {
      colRight.appendChild(newShiftButtonEle);
      if ($.session.flag.copyShifts) {
        colRight.appendChild(copyShiftsButtonEle);
      }
      colRight.appendChild(pubUnpubButtonEle);
    }

    scheduleNav.appendChild(scheduleFilter);
    scheduleNav.appendChild(colRight);
    scheduleWrap.appendChild(scheduleNav);
    scheduleWrap.appendChild(ScheduleCalendar.rootEle);

    _DOM.ACTIONCENTER.innerHTML = '';
    _DOM.ACTIONCENTER.appendChild(scheduleWrap);

    ScheduleCalendar.renderCalendar();
  }

  function resetModule() {
    // DOM
    ScheduleCalendar = undefined;
    locationDropdownEle = undefined;
    employeeDropdownEle = undefined;
    shiftTypeDropdownEle = undefined;
    shiftTypeNote = undefined;
    pubUnpubButtonEle = undefined;
    newShiftButtonEle = undefined;

    // DATA
    schedules = undefined;
    appointments = undefined;
    calendarEvents = undefined;
    calendarAppointments = undefined;
    locations = undefined;
    employees = undefined;
    rosterCache = {};

    // GLOBALS
    currentCalView = undefined;
    selectedLocationId = undefined;
    selectedEmployeeId = undefined;
    selectedShiftType = undefined;
    viewOptionShifts = undefined;

    // Shift Popups
    SchedulingShifts.reset();
  }
  async function init() {
    resetModule();

    console.clear();

    currentCalView = 'month';
    viewOptionShifts = 'no';
    showOtherEmployeeShifts = 'no'; // T.215199 default
    selectedEmployeeId = $.session.PeopleId;
    selectedLocationId = '%';

    ScheduleCalendar = new Calendar({
      defaultView: currentCalView,
      onEventClick: handleCalendarEventClick,
      onViewChange(newView) {
        currentCalView = newView;
        // T.215199: show/hide the non-scheduler toggle for Week/Day, and if the user
        // leaves those views while it is on, revert to their own shifts and refresh.
        updateOtherEmployeeShiftToggleVisibility();
        const inWeekOrDay = newView === 'week' || newView === 'day';
        if (!inWeekOrDay && showOtherEmployeeShifts === 'yes') {
          showOtherEmployeeShifts = 'no';
          const noInput =
            otherEmployeeShiftNoRadio && otherEmployeeShiftNoRadio.querySelector('input');
          const yesInput =
            otherEmployeeShiftYesRadio && otherEmployeeShiftYesRadio.querySelector('input');
          if (noInput) noInput.checked = true;
          if (yesInput) yesInput.checked = false;
          reloadCalendarEventsForOtherShifts();
        }
      },
      async getEventDataCallback(newDateRange, force = false) {
        if (!force) {
          const hasEventsForView = hasEventsForViewableDateRange(newDateRange);

          if (hasEventsForView) {
            return null;
          }
        }

        const [eventsResp, appointmentsResp] = await Promise.all([
          getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
          getCalendarAppointments(selectedLocationId),
        ]);

        calendarEvents = eventsResp;
        calendarAppointments = appointmentsResp;

        return { events: calendarEvents, appointments: calendarAppointments };
      },
      onEventRender(eventsInView) {
        const unpublishedEvents = eventsInView.filter(
          event => !event.publishedDate && event.typeId !== 6,
        );
        updateShiftTypeNote(unpublishedEvents.length);
      },
    });

    build();

    try {
      const [employeesResp, locationsResp, appointmentsResp] = await Promise.all([
        _UTIL.fetchData('getAllEmployees', { userId: $.session.UserId }),
        _UTIL.fetchData('getLocationDropdownForSchedulingNew', { showOpenShifts: 'N' }),
        getCalendarAppointments(selectedLocationId),
      ]);

      employees = employeesResp.getAllEmployeesResult;
      locations = locationsResp.getLocationDropdownForSchedulingNewResult;
      calendarAppointments = appointmentsResp;
      calendarEvents = await getCalendarEvents(selectedLocationId, getEffectiveEmployeeId());

      populateEmployeeDropdown();
      populateLocationDropdown();
      renderCalendarEvents();
    } catch (error) {
      employees = [];
      locations = [];
      calendarEvents = [];
      calendarAppointments = [];
    }

    if (viewOptionShifts === 'no') {
      const filterCheck = value => value !== 3 && value !== 4;
      ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
    }

    SchedulingShifts.init({
      ScheduleCalendar,
    });
  }

  return {
    init,
    renderCalendarEvents,
    getAppointments: () => appointments,
    fetchCalendarEvents: async () => {
      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, getEffectiveEmployeeId()),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;
    },
    getCalendarEventData: () => calendarEvents,
    getSchedules: () => schedules,
    getLocations: () => locations,
    getSelectedLocationId: () => selectedLocationId,
    getSelectedEmployeeId: () => selectedEmployeeId,
    abbreviateAppointment,
  };
})();
